<template>
  <div class="pa-ovl" role="dialog" aria-modal="true" aria-labelledby="pa-request-updates-title" @click.self="close">
    <div class="pa-cmodal">
      <div class="pa-cmodal__icon"><i class="material-icons" aria-hidden="true">edit_note</i></div>
      <h3 id="pa-request-updates-title" class="pa-cmodal__title">Request updates: {{ keyword }}</h3>
      <p class="pa-cmodal__body">Tell our writers what to change. They usually turn revisions around in 2 to 3 business days, and the review window restarts when the revised draft lands.</p>
      <textarea
        ref="text"
        v-model="text"
        class="pa-cmodal__text"
        maxlength="4000"
        placeholder="What should we update? (tone, facts, structure, links...)"
        :disabled="busy"
      ></textarea>
      <div class="pa-cmodal__acts">
        <button type="button" class="pa-btn pa-btn--out" :disabled="busy" @click="close">Cancel</button>
        <!-- design Modal `textRequired`: nothing to send until the box has text -->
        <button
          type="button"
          class="pa-btn pa-btn--orange"
          :disabled="busy || !text.trim()"
          @click="submit"
        >Send request</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * "Request updates" on one delivered article (design pa-app.jsx `onRequestUpdates` + Modal: 520px box,
 * round edit_note icon, required text). Emits `close`, and `confirm` with { text }.
 */
export default {
  name: 'PopAuthorityRequestUpdatesModal',
  props: {
    keyword: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },
  data () {
    return {
      text: '',
    }
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydown)
    this.$nextTick(() => {
      if (this.$refs.text) this.$refs.text.focus()
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown (event) {
      if (event.key === 'Escape') this.close()
    },
    close () {
      if (this.busy) return
      this.$emit('close')
    },
    submit () {
      const text = (this.text || '').trim()
      if (!text || this.busy) return
      this.$emit('confirm', { text })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';
@import './setup/designModal.scss';
</style>
